import {TrustStatus} from '@sollapay/enums';

export const isTrustInActivationPhase = (trustStatus: TrustStatus): boolean =>
  trustStatus !== TrustStatus.TRUST_ACTIVE;

export const getTrustAccountActivationPath = (trustAccountId: string): string =>
  `/trust-accounts/${trustAccountId}/activation`;

/** An account still in activation opens its activation page instead of the requested tab. */
export function getTrustAccountPath(
  account: {id: string; trustStatus: TrustStatus},
  {tab = '', search = ''}: {tab?: string; search?: string} = {}
): string {
  const path = isTrustInActivationPhase(account.trustStatus)
    ? getTrustAccountActivationPath(account.id)
    : `/trust-accounts/${account.id}${tab}`;
  return `${path}${search}`;
}
